import React from "react";
import "./custom-checkbox.scss";

const CustomCheckBox = (props) => {
    return (
        <>
            <label className="check-box" checked="checked">
                <input
                    type="checkbox"
                    onChange={props.onChange}
                    name={props.name}
                    value={props.value}
                />
                <span className="checkmark-new"></span>
            </label>
        </>
    );
};

export default CustomCheckBox;
